/* IncidentLogsModal.js with Bootstrap 5.3.3, log-only, polling for multi-user, log- prefixes - 06-24-25 */
/* 6/24/25 this is working w/o react-bootstrapt and B5 need to clean up format later */
/* 7/25/25: updated get the modal to work. change class to func comp and fix profile/state */
/* IncidentLogModal.js — Bootstrap 5, clean overlay (no BS JS), polling, log-only */
/* Drop-in: uses internalMessages actions and Messages component exactly like Chat/Notes */
/* Drop-in fix: since 9-22-25 console not see log entries.. they were typed ..
   - ✅ include Auth0 token on fetch/post
   - ✅ post legacy-safe payload { message, sent }
   - ✅ refresh list immediately after post
   - ✅ keep your wiring and Messages props intact */


import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "../../actions/modal";
import {
  fetchInternalMessages,
  postInternalMessage,
  updatePendingMessage,
  clearPendingMessage,
  clearMessages,
} from "../../actions/internalMessages";
import { useAuth0 } from "@auth0/auth0-react";          // ✅ CHANGE: need token
import Messages from "../../views/Messages/Messages";
import "./IncidentLogModal.css";

const IncidentLogModal = () => {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();        // ✅ CHANGE: token getter

  const pollRef = useRef(null);

  const visible = useSelector((state) => state.modal?.visible || false);
  const modalProps = useSelector((state) => state.modal?.modalProps || {});
  const internalMessages = useSelector((state) => state.internalMessages || {});
  const profile = useSelector((state) => state.profile || {});

  const { incident, agencyId, reportSchemaId } = modalProps;

  const hasProfile =
    profile && typeof profile.sub === "string" && profile.sub.length > 0;

  const hide = () => {
    // unlock scroll, remove our manual backdrop, and hide modal
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
    const backdrop = document.querySelector(".log-modal-backdrop");
    if (backdrop) backdrop.remove();
    dispatch(hideModal());
  };

  const closeLog = () => hide();

  // ✅ CHANGE: wrap fetch with token; pass token to thunk (mirror Chat/Notes)
  const prepareFetch = async () => {
    if (!incident?._id) return;
    try {
      const token = await getAccessTokenSilently(); // token for Authorization header
      await dispatch(
        fetchInternalMessages(incident._id, agencyId, reportSchemaId, token)
      );
      // If your thunk ignores the extra arg, no harm done; but update it to use the token.
    } catch (e) {
      console.error("[Log] fetch failed:", e);
    }
  };

  const addMessage = async () => {
    const pending = internalMessages.pendingMessage;
     if (!pending?.trim() || !incident?._id) return;

    const payload = {
      message: pending,
      sent: Date.now(),
      sender_id: profile?.sub,
      display_name: profile?.user_metadata?.name || profile?.name,
      // type: "log",
    };
try {
      const token = await getAccessTokenSilently(); // ✅ include token on POST
      await dispatch(
        postInternalMessage(incident._id, agencyId, reportSchemaId, payload, token)
      );
      dispatch(clearPendingMessage());
      // force a refresh so the new entry appears even if reducer isn’t optimistic
      prepareFetch();                                  // ✅ CHANGE
    } catch (e) {
      console.error("[Log] post failed:", e);
    }
  };

  // Fetch on open
  useEffect(() => {
    if (visible && incident?._id) {
      prepareFetch();
    }
    
  }, [visible, incident?._id]); // eslint-disable-line react-hooks/exhaustive-dep

  // Poll every 10s while visible
  useEffect(() => {
    if (!visible || !incident?._id) return;
    clearInterval(pollRef.current);
    pollRef.current = setInterval(() => {
      prepareFetch();
    }, 10000);
    return () => clearInterval(pollRef.current);
    
  }, [visible, incident?._id]);

  // Body lock while open
  useEffect(() => {
    if (visible) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [visible]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      // If you want to clear internal messages on close, uncomment next line:
      // dispatch(clearMessages());
      hide();
      clearInterval(pollRef.current);
    };
   
  }, []);

  if (!visible || !incident?._id) return null;

  const logOnly =
    Array.isArray(internalMessages.messages)
      ? internalMessages.messages
      : [];

  return (
    <div>
      {/* Manual backdrop */}
      <div className="log-modal-backdrop fade show" />

      {/* Modal container — CSS-controlled visibility (no Bootstrap JS) */}
      <div
        className={`log-modal ${visible ? "show d-block" : ""}`}
        id="log-modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="logModalLabel"
        aria-hidden={!visible}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="log-modal-dialog modal-dialog-centered" role="document">
          <div className="log-modal-content">
            <div className="log-modal-header">
              <h5 className="log-modal-title d-flex align-items-center" id="logModalLabel">
                <i className="material-icons me-2">view_headline</i>
                <span>
                  Log - {incident.display_title || "INC-Unknown"} - {incident.title || "Untitled"}
                </span>
              </h5>
              <button
                type="button"
                className="log-modal-close"
                onClick={closeLog}
                aria-label="Close"
              >
                Close X
              </button>
            </div>

            <div className="log-modal-body" id="log-modal-body">
              <Messages
                closeTitle="Close Log"
                incident={incident}
                messages={logOnly}
                pendingMessage={internalMessages.pendingMessage || ""}
                hide={closeLog}
                clearMessages={clearMessages}
                updatePendingMessage={updatePendingMessage}
                addMessage={addMessage}
                closeModal={closeLog}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncidentLogModal;
